{
  "forms": {
    "none": "None"
  },
  "create": {
    "modal_title": "Create New Column",
    "column_name_label": "Column name",
    "add_column_button": "Add Column",
    "add_column_aria_label": "Add Column",
    "validation": {
      "name_required": "Please come up with a name for the new field",
      "type_required": "Please select a type for the new field",
      "options_required": "Please tell us what are the options",
      "currency_required": "Please select a currency"
    },
    "yes_no_options": {
      "yes": "Yes",
      "no": "No"
    }
  },
  "value_type": {
    "label": "Value Type"
  },
  "remove": {
    "confirmation_title": "Are you sure you want to remove this field?",
    "aria_label": "remove custom field"
  },
  "options": {
    "modal_title": "New Options",
    "add_button": "Option",
    "value_label": "Option Value",
    "remove_aria_label": "remove option",
    "validation": {
      "values_required": "Please enter the new values"
    },
    "update": {
      "modal_title": "Update Option Value",
      "value_label": "Option value",
      "validation": {
        "value_required": "Please enter a value",
        "colour_required": "Please select a colour"
      }
    },
    "new_chip_label": "New Options"
  },
  "schema": {
    "update_aria_label": "update custom field schema",
    "edit_title": "Edit Field",
    "field_name_label": "Field Name"
  }
}
